import { useContext } from 'react';

import { AppContext, AppContextDispatch } from './context';

export const useAppDispatch = () => {
  const dispatch = useContext(AppContextDispatch);

  return dispatch;
};

export const useAppContext = () => {
  const store = useContext(AppContext);

  return store;
};
